import { useQuery } from '@tanstack/react-query';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

const useGetReleaseNote = (id: string) =>
  useQuery({
    queryKey: ['release-note', id],

    queryFn: async () => {
      const { data } = await axiosInstance.get(API_ROUTES.releaseNote(id));

      return data;
    },
    enabled: !!id,
  });
export default useGetReleaseNote;
